import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

// Mesma chave e formato JSON que o script de pré-pintura do index.html lê.
export const THEME_STORAGE_KEY = 'cobler-theme';

export type Theme = 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

const readStoredTheme = (): Theme => {
  try {
    return JSON.parse(localStorage.getItem(THEME_STORAGE_KEY) ?? 'null') === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

/** Preferência de tema do usuário, compartilhada entre o sync do cabeçalho e o switch do menu do usuário. */
const useThemeStore = create<ThemeState, [['zustand/devtools', never]]>(
  devtools(
    (set) => ({
      theme: readStoredTheme(),
      setTheme: (theme) => {
        try {
          localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(theme));
        } catch {
          // Sem storage o tema vale só para a sessão.
        }
        set({ theme }, false, 'theme/set');
      },
    }),
    { name: 'useThemeStore' }
  )
);

export default useThemeStore;
